import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { Button } from "react-bootstrap";
import { Input } from "../../ui";
import swal from "sweetalert";
import axios from "axios";

import { CustomForm, CustomModal } from "../../components";
import {
  useFetchAllSportsQuery,
  useFetchAllNewsNetQuery,
  useFetchSingleCustomAdvertiserQuery,
  useFetchProfilesQuery,
  useFetchGameStatesQuery
} from "../../store/api/apiSlice";
import SportSection from "../sportSection/SportSection";
import { useForumContext } from "../../components/context/ForumContext";
import MyTeam from "../MyTeam/MyTeam";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import LeftSideAnimation from "../animations/LeftAndRightSideAnimation";
import { useTheme } from "../context/ThemeContext";

const SideNav = ({
  navbarData,
  isAdmin = false,
  selected,
  setSelected,
  image,
  setImage,
}) => {
  const { data: NewLinkData } = useFetchAllNewsNetQuery();
  const token = JSON.parse(localStorage.getItem("token"));

  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const userCreatedat = JSON.parse(localStorage.getItem("user"))?.createdAt;
  const { fgColor, bgColor } = useTheme();
const {
    data: fetchGameStates,
    isLoading,
    error,
  } = useFetchGameStatesQuery(token?.userId);
  const userCreatedDateTime = new Date(userCreatedat);
  const gameDeadline = moment(userCreatedDateTime).add(1, "year").toDate();
  const currentDateTime = new Date();
  const timeLeftMilliseconds =
    gameDeadline.getTime() - currentDateTime.getTime();

  let formattedTimeLeft;

  if (timeLeftMilliseconds < 0) {
    formattedTimeLeft = "0D 0H 0M";
  } else {
    const duration = moment.duration(timeLeftMilliseconds);
    formattedTimeLeft = `${Math.floor(
      duration.asDays()
    )}D ${duration.hours()}H ${duration.minutes()}M`;
  }

  const {
    setSelectedForum,
    updateSelectedSport,
    setSelectedSport,
    updateSelectedForum,
    updateSelectedSchool,
  } = useForumContext();
  const { data: sportsData, isLoading: isSportsLoading } =
    useFetchAllSportsQuery();

  const [initialSelectedSports, setInitialSelectedSports] = useState([]);
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const {
    data: profileData,
    isLoading: isprofileLoading,
    refetch: refetchProfile,
  } = useFetchProfilesQuery();
  const college = profileData?.user.school_name;

  const {
    data: singleCustomAdvertiser,
    refetch: refetchSingleCustomAdvertiser,
  } = useFetchSingleCustomAdvertiserQuery(profileData?.user?.school_name, {
    skip: !profileData?.user?.school_name,
  });

  const newsAdvertiser = singleCustomAdvertiser?.advertisers?.find(
    (ad) => ad.type === "news"
  );
    const [invitees, setInvitees] = useState([{ fname: "", lname: "" }]);
    const [isInviteButtonDisabled, setIsInviteButtonDisabled] = useState(false);
  
    const [generatedLink, setGeneratedLink] = useState("");
    const [generatedMessage, setGeneratedMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [step, setStep] = useState(0);
  const [isForumSelected, setIsForumSelected] = useState(false);
  const [isMyTeamSelected, setIsMyteamSelected] = useState(false);
  const [isTop25Selected, setIsTop25Selected] = useState(false);
  const [isNetSelected, setIsNetSelected] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const [isNetNews, setIsNetNews] = useState(false);
  const navigate = useNavigate();
  const handleAddInvitee = () => {
    setIsInviteButtonDisabled(false);
    setInvitees([...invitees, { fname: "", lname: "" }]);
  };
  const handleRemoveInvitee = (index) => {
    const newInvitees = invitees.filter((_, i) => i !== index);
    setInvitees(newInvitees);
  };

  const handleChange = (index, field, value) => {
    const newInvitees = [...invitees];
    newInvitees[index][field] = value;
    setInvitees(newInvitees);
  };

  const handleTypeClick = (type) => {
    setIsNetNews(true);
    setSelectedType(type);
    if (type === "top25") {
      setIsTop25Selected(true);
      setIsForumSelected(false);
      setIsMyteamSelected(false);
      setIsNetSelected(false);
    } else if (type === "net") {
      setIsNetSelected(true);
      setIsTop25Selected(false);
      setIsForumSelected(false);
      setIsMyteamSelected(false);
    }
  };
  const handleForumClick = () => {
    setIsForumSelected(true);
    setIsMyteamSelected(false);
    setIsTop25Selected(false);
    setIsNetSelected(false);
    setIsNetNews(false);
    updateSelectedForum("viewAll");
    setSelectedForum("viewAll");
  };
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const handleMyTeamClick = () => {
    setIsForumSelected(false);

    setIsTop25Selected(false);
    setIsNetSelected(false);
    setIsNetNews(false);
    setIsModalOpen2(true);
    setIsMyteamSelected(true);
    setIsForumSelected(false);
  };
  const handleImageClickUrl = (sport) => {
    if (isForumSelected) {
      updateSelectedSchool(college);
      setSelectedSport(sport);
      updateSelectedSport(sport);
      navigate(`/forumlist`);
    } else if (isNetNews) {
      if (NewLinkData && NewLinkData.top_net_links) {
        const matchedLink = NewLinkData.top_net_links.find(
          (link) => link.type === selectedType && link.sports_name === sport
        );

        if (matchedLink) {
          window.open(matchedLink.resource_URL, "_blank");
        } else {
          toast.error("No Match Found");
        }
      }
    }
  };
  useEffect(() => {
    if (profileData && profileData.user) {
      const { favorite_sports = [] } = profileData.user;
      const favoriteSports = favorite_sports[0]
        ? JSON.parse(favorite_sports[0])
        : [];
      const selectedSports = favoriteSports
        .map((athlete) => athlete.name)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setInitialSelectedSports(selectedSports);
    } else {
    }
  }, [profileData]);
  const getMatchedSports = () => {
    if (!sportsData || !sportsData.sports) return [];

    return initialSelectedSports
      .map((selectedSport) => {
        return sportsData.sports.find((sport) => sport.name === selectedSport);
      })
      .filter((sport) => sport);
  };
  useEffect(() => {
    refetchProfile();
  }, []);
  const matchedSports = getMatchedSports();
  
  const handleTextClick = () => {
    setSelectedField("text");
    setIsModalOpen(true);

    setStep(1);
  };
const handleModalClose = () => {
    resetStates();
    setIsModalOpen(false);
  };
  const resetStates = () => {
    setInvitees([{ fname: "", lname: "" }]);
    setIsInviteButtonDisabled(false);
    setGeneratedLink("");
    setGeneratedMessage("");
  };
  const handleCopyLink = () => {
    try {
      navigator.clipboard.writeText(generatedMessage);

      setTimeout(() => {
        swal({
          title: "",
          text: "Message copied to clipboard!",
          icon: "success",
          timer: 5000,
        });
        resetStates();
        // setIsModalOpen(false);
      }, 1000);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = generatedMessage;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.success("Message copied to clipboard!");
    }
  };
  const handleGenerateLink = async () => {
    if (
      invitees.some(
        (invitee) => invitee.fname.trim() === "" || invitee.lname.trim() === ""
      )
    ) {
      setTimeout(() => {
        swal({
          title: "",
          text: "Please fill in all the invitee names.",
          icon: "error",
          timer: 5000,
        });
      }, 1000);
      return;
    }
    const updatedInvitees = invitees.map((invitee) => ({
      ...invitee,
      invited: true,
    }));
    setInvitees(updatedInvitees);
    const inviteesData = invitees.map((invitee) => ({
      invitee_fname: invitee.fname,
      invitee_lname: invitee.lname.charAt(0),
    }));
    const body = {
      InviteesData: inviteesData,
      playgame: {
        inviter: profileData.user._id,
        invited_date: new Date().toLocaleDateString("en-CA"),
        invitee_clicked: false,
        invitee_signup: false,
        invitee_paid: false,
        is_email_success: false,
        invitee_response: false,
        invitee_response_datetime: "",
        invitee_profile_id: "",
        is_award_retained: false,
        is_charitable: false,
        charitableProgram: "",
      },
    };

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;
      const currentOrigin = window.location.origin;

      const response = await axios.post(
        `${baseUrl}/api/play-game/createOrUpdatePlayGame`,
        body,
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );

      if (response.data.message) {
        const invitationLink = `${currentOrigin}/invitation/${response.data.updatedRecord.randomId}`;

        const invitees = response.data.addedinvitee;

        const inviteesNames = invitees
          .map((invitee) => `${invitee.invitee_fname} ${invitee.invitee_lname}`)
          .join(", ");

        const personalizedMessage = `Dear\n ${inviteesNames},\n\nI would like to invite you to join CSFA through the link below:\n${invitationLink}\n\nBest regards,\n${
          profileData?.user.firstName || "Your Name"
        }`;
        setGeneratedLink(invitationLink);
        setGeneratedMessage(personalizedMessage);
        localStorage.setItem("generatedInvitationLink", personalizedMessage);

        setTimeout(() => {
          swal({
            title: "",
            text: response.data.message,
            icon: "success",
            timer: 5000,
          });
        }, 1000);
        setIsInviteButtonDisabled(true);
      } else {
        toast.error("Unexpected response from server.");
      }
    } catch (error) {
      toast.error("Failed to send invites. Please try again.");
    }
  };
  useEffect(() => {
    const existingLink = localStorage.getItem("generatedInvitationLink");
    if (existingLink) {
      setGeneratedLink("");
    }
  }, []);
  return (
    <>
    <CustomModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        style={{
          scrollbarColor: bgColor ? `${bgColor} #f1f1f1` : "#704fe6 #f1f1f1",
          scrollbarWidth: "thin",
        }}
      >
        <CustomForm className="sideNav_customForm">
          <>
            <h3
             className="rightSideNav_HeaderText"
            >
              Invite Recruit(s){" "}
            </h3>
            <hr className="rightSideNav_divider" />
            <p className="pb-2">
              <strong> Step 1:</strong> Enter First and Last name of each
              recruit. Click Invite Recruit(s).{" "}
            </p>
            <h3
              className="pb-2 rightSideNav_texth3"
             
            >
              Add the recruits you want to invite:
            </h3>
            {invitees.map((invitee, index) => (
              <div
                key={index}
                  className="rightSideNav_MainDiv"
              >
                <div
                  
                  className="col-4 rightSideNav_MainDiv2"
                >
                  <Input
                    placeholder="First Name"
                    label="First Name"
                    type="text"
                    value={invitee.fname}
                    onChange={(e) =>
                      handleChange(index, "fname", e.target.value)
                    }
                    style={{ marginRight: "10px" }}
                  />
                </div>
                <div
                  
                  className="col-4 rightSideNav_MainDiv2"
                >
                  <Input
                    placeholder="Last Name"
                    label="Last Name"
                    type="text"
                    value={invitee.lname}
                    onChange={(e) =>
                      handleChange(index, "lname", e.target.value)
                    }
                    style={{ marginRight: "10px" }}
                  />
                </div>
                {invitee.invited ? (
                  <span  className="rightSideNav_invitedSpan">Invited</span>
                ) : (
                  <span
                      className="rightSideNav_Not_invitedSpan"
                  ></span>
                )}

                <button
                  onClick={() => handleRemoveInvitee(index)}
                  className="Minus-btn rightSideNav_removeBtn"
                 
                >
                  -
                </button>
              </div>
            ))}
            <div className="rightSideNav_addBtn_Div">
              <h5
                onClick={handleAddInvitee}
                variant="contained"
                fullWidth
                className="hoverable"
              >
                Add More
              </h5>
            </div>

            <div className="rightSideNav_InviteBtn">
              <Button
                onClick={handleGenerateLink}
                disabled={isInviteButtonDisabled}
                variant="contained"
                fullWidth
                className="btn-primary1"
                style={{ marginBottom: "15px", marginLeft: "0 !important" }}
              >
                Invite Recruit(s)
              </Button>
            </div>
            <p className="pb-2">
              <strong>Step 2:</strong> Customize and copy the message including
              the link. Close the popup.{" "}
            </p>
          </>

          <>
            <div className="rightSideNav_GenerateLink">
              <p>Link:</p>
              <p>{generatedLink}</p>
              <label>Generated Message:</label>
              <div
                  className="rightSideNav_GenerateMsg"
              >
                <textarea
                  type="text"
                  value={generatedMessage}
                  readOnly
                   className="rightSideNav_GenerateMsg"
                />
                <Button
                  onClick={handleCopyLink}
                  variant="outlined"
                  size="small"
                 className="btn-primary rightSideNav_copyBtn"
                 
                >
                  Copy
                </Button>
              </div>
              <p className="pb-2">
                <strong>Step 3:</strong>Open your favorite Text/Email app. Add
                Your Personalized message and include the copied text and send.
              </p>
            </div>
          </>
        </CustomForm>
      </CustomModal>
      {!isAdmin && (
        <div className="card">
          <SportSection
            selected={selected}
            setSelected={setSelected}
            image={image}
            setImage={setImage}
          />
        </div>
      )}
      {isprofileLoading ? (
        <Skeleton height={200} />
      ) : (
        <>
          {!isAdmin && (
            <div className="card">
              <div className="card-body px-0">
                <div className="heading_box">
                  <h4
                    className="broughttoyou rightSideNav_CustomModal_header ps-3"
                  
                  >
                    Brought To You By
                  </h4>
                </div>

                {newsAdvertiser ? (
                  <a
                    href={newsAdvertiser.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      key={newsAdvertiser._id}
                      src={`${baseUrl}/${newsAdvertiser.businessLogo}`}
                      alt={newsAdvertiser.businessName}
                      className="broughtimage img-fluid px-3"
                    />
                  </a>
                ) : (
                  <h6 className="rightSideNav_NoAd">
                    No News Ads available.
                  </h6>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {!isAdmin && (
        <div className="card">
          <div className="card-body px-0">
            <div className="heading_box">
              <h4 className="broughttoyou ps-3 rightSideNav_CustomModal_header">
                Chalk Talk-Chat Room
              </h4>
            </div>
            <div className="forum_div px-3">
              <div
               className="rightSideNav_ForumDiv"
              >
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: isForumSelected
                      ? "antiquewhite"
                      : "transparent",
                    borderRadius: isForumSelected ? "15px" : "0",
                  }}
                >
                  <Link to="#" className="forumlink" onClick={handleForumClick}>
                    FORUM{" "}
                  </Link>
                </div>
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: isMyTeamSelected
                      ? "antiquewhite"
                      : "transparent",
                    borderRadius: isMyTeamSelected ? "15px" : "0",
                  }}
                >
                  <Link
                    to="#"
                    className="forumlink"
                    onClick={handleMyTeamClick}
                  >
                    MY TEAM
                  </Link>
                </div>
              </div>
            </div>
            <MyTeam
              isModalOpen2={isModalOpen2}
              setIsModalOpen2={setIsModalOpen2}
            />
            <div
              className="mb-3 px-3 rightSideNav_MatchedSport"
              
            >
              {(isSportsLoading || isprofileLoading) &&
                Array(3)
                  .fill(0)
                  .map((_, index) => (
                    <div key={index} style={{ padding: "4px" }}>
                      <Skeleton circle={true} height={50} width={50} />
                    </div>
                  ))}
              {!isSportsLoading &&
                !isprofileLoading &&
                matchedSports.map((sport, index) => (
                  <img
                    key={sport._id}
                    src={`${baseUrl}/${sport.sportsFile}`}
                    alt={sport.name}
                    className="chatimage22 rightSideNav_MatchedSportImg"
      
                    onClick={() => handleImageClickUrl(sport.name)}
                  />
                ))}
            </div>
            <div className="forum_div px-3">
              <div
                 className="rightSideNav_Top25"
              >
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: isTop25Selected
                      ? "antiquewhite"
                      : "transparent",
                    borderRadius: isTop25Selected ? "15px" : "0",
                  }}
                >
                  <Link
                    className="forumlink f14 p73"
                    onClick={() => handleTypeClick("top25")}
                  >
                    TOP 25
                  </Link>
                </div>
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: isNetSelected
                      ? "antiquewhite"
                      : "transparent",
                    borderRadius: isNetSelected ? "15px" : "0",
                  }}
                >
                  <Link
                    className="forumlink f14"
                    onClick={() => handleTypeClick("net")}
                  >
                    Net’l Score
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
  {isLoading ? (
        <Skeleton height={300} />
      ) : (
        <div
          className="card "
          id="purpleright"
          style={{ backgroundColor: bgColor, color: fgColor }}
        >
          <div className="card-body ">
            <div className="purplecardheading">
              <LeftSideAnimation x={100}>
                <h4 className="gamestatustext">Your Play The Game Status</h4>
              </LeftSideAnimation>
            </div>
            <LeftSideAnimation x={100}>
              <p className="time-left">Time left in the Game</p>
            </LeftSideAnimation>
            <LeftSideAnimation x={100}>
              <h6 className="info-label2">{formattedTimeLeft}</h6>
            </LeftSideAnimation>
            <div className="row mt-4">
              <div className="col-6">
                <LeftSideAnimation x={100}>
                  <p className="info-label">Total Recruits</p>
                </LeftSideAnimation>
                <LeftSideAnimation x={100}>
                  <h6 className="info-label2">
                    {fetchGameStates?.stats?.totalInvitees}
                  </h6>
                </LeftSideAnimation>
              </div>
              <div className="col-6">
                <LeftSideAnimation x={100}>
                  <p className="info-label">Signed Recruits</p>
                </LeftSideAnimation>
                <LeftSideAnimation x={100}>
                  <h6 className="info-label2">
                    {fetchGameStates?.stats?.totalSignups}
                  </h6>
                </LeftSideAnimation>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <LeftSideAnimation x={100}>
                  <p className="info-label">Status level</p>
                </LeftSideAnimation>
                <LeftSideAnimation x={100}>
                  <h6 className="info-label2">
                    {fetchGameStates?.stats?.userPTGlevel}
                  </h6>
                </LeftSideAnimation>
              </div>
              <div className="col-6">
                <LeftSideAnimation x={100}>
                  <p className="info-label">Qty to reach team</p>
                </LeftSideAnimation>
                <LeftSideAnimation x={100}>
                  <h6 className="info-label2">
                    {(fetchGameStates?.stats?.totalInvitees ?? 0) -
                      (fetchGameStates?.stats?.totalSignups ?? 0)}
                  </h6>
                </LeftSideAnimation>
              </div>
            </div>
          </div>
          <div
            className="card-footer text-center text-white rightSideNav_timeLeft"
          
          >
            <LeftSideAnimation x={100}>
              {formattedTimeLeft !== "0D 0H 0M" && (
                <button
                  className="btn btn-light2 w-100"
                  onClick={handleTextClick}
                >
                  Invite Recruit (s)
                </button>
              )}
            </LeftSideAnimation>
          </div>
        </div>
      )}
      {isAdmin &&
        navbarData &&
        navbarData.map((data) => (
          <div className="card">
            <div className="card-body px-0">
              <div className="heading_box">
                <Link to={data.route} className="broughttoyou ps-3">
                  {data.title ? data.title : "Brought To You By"}
                </Link>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default SideNav;
